import styled from 'styled-components';
import { FontWeight } from '../../../Typography/Typography';

export const StyledExtraItem = styled.div`
  font-weight: ${FontWeight.MEDIUM};
  font-size: 14px;
  height: 48px;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colorSurfaceVariant};
  && {
    color: ${({ theme }) => theme.colorPrimary};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colorPrimaryContainer};
  }
`;
